import { styled } from '@mui/material/styles';

export const StyledBulkActionContainer = styled('div')`
  display: flex;

  margin-top: ${({ theme }) => theme.spacing(1.5)};
  gap: ${({ theme }) => theme.spacing(1)};
`;
